<span
    class="badge badge-cliente-carteira-tipo badge-cliente-carteira-tipo-pretendida"
    [ngClass]="{'pipeline-card-title-badge': isPipelineCardTitleBadge}"
    [title]="tipo.nome + (idClassificacaoFaturamentoPretendida ? ' (Classificação de Faturamento Pretendida: ' + nomeClassificacaoFaturamentoPretendida + ') ' : '')">
    {{tipo.abreviacao}}
    <span *ngIf="idClassificacaoFaturamentoPretendida">
        ({{codigoClassificacaoFaturamentoPretendida}})
    </span>                    
</span>